import Pie from './pie';

export default Pie;